import { useEffect } from 'react';

// This hook is now simplified - notifications are created server-side via PocketBase hooks
// See POCKETBASE_NOTIFICATION_HOOKS.md for setup instructions
export const useCommentReactionNotifications = () => {
  useEffect(() => {
    console.log('📢 Notification system active. Notifications are created server-side via PocketBase hooks.');
    console.log('📋 See POCKETBASE_NOTIFICATION_HOOKS.md for setup instructions.');
  }, []);
};
